/**
 * @author Daniel Aguirre
 * @file routes.js
 * @description Patient routes
 */

// Pages
import EducationalMaterialCategories from '@nephro/pages/EducationalMaterial/EducationalMaterialCategories';
import EducationalMaterialElements from '@nephro/pages/EducationalMaterial/EducationalMaterialElements';
import EducationalMaterialView from '@nephro/pages/EducationalMaterial/EducationalMaterialView';
import EducationalMaterialLoad from '@nephro/pages/EducationalMaterial/EducationalMaterialLoad';
import EducationalMaterialEdit from '@nephro/pages/EducationalMaterial/EducationalMaterialEdit';

const pathStart = '/main/educational-material';
const routes = [
  {
    path: `${pathStart}/`,
    isProtected: true,
    component: EducationalMaterialCategories,
    exact: true
  },
  {
    path: `${pathStart}/category/:name/:id`,
    isProtected: true,
    component: EducationalMaterialElements,
    exact: true
  },
  {
    path: `${pathStart}/category/:name/:id/load`,
    isProtected: true,
    component: EducationalMaterialLoad,
    exact: true
  },
  {
    path: `${pathStart}/category/:name/:id/edit`,
    isProtected: true,
    component: EducationalMaterialEdit,
    exact: true
  },
  {
    path: `${pathStart}/element/:category/:name/:id`,
    isProtected: true,
    component: EducationalMaterialView,
    exact: true
  },
  { redirect: true, to: `${pathStart}/` }
];

export default routes;
